import { CircleX } from "lucide-react";
import { type ReactNode, useCallback, useState } from "react";

import { Stack } from "core/components/Stack";
import { WithTooltip } from "core/components/WithTooltip";
import {
  Popover,
  PopoverAnchor,
  PopoverContent,
} from "core/shadcn/components/ui/popover";
import localStorage from "legacy/utils/localStorage";
import { STORAGE_KEYS } from "legacy/utils/StorageUtils";

export const IntercomPopover = ({ children }: { children?: ReactNode }) => {
  const [hasDismissed, setHasDismissed] = useState(
    !!localStorage.getItem(STORAGE_KEYS.SHOW_INTERCOM_POPOVER_KEY),
  );

  const chatPrompt = "Chat with a Superblocks Engineer";

  const onDismiss = useCallback(() => {
    localStorage.setItem(STORAGE_KEYS.SHOW_INTERCOM_POPOVER_KEY, "true");
    setHasDismissed(true);
  }, []);

  if (hasDismissed) {
    return (
      <WithTooltip content={chatPrompt} side="right">
        {children}
      </WithTooltip>
    );
  }

  // The hint stays open until the close icon is clicked, so it has no trigger
  // and ignores outside clicks. It must not take focus from the page.
  return (
    <Popover open>
      <PopoverAnchor asChild>{children}</PopoverAnchor>
      <PopoverContent
        side="right"
        className="w-auto px-4 py-3"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <Stack align="center">
          <span>{chatPrompt}</span>
          <button type="button" aria-label="Dismiss" onClick={onDismiss}>
            <CircleX className="size-4 cursor-pointer text-sb-grey-300" />
          </button>
        </Stack>
      </PopoverContent>
    </Popover>
  );
};
